import { createUseStyles } from '@glu/theming';

const styles = ({ palette: { primary }, spacing: { unit } }) => ({
  intro: {
    opacity: '0',
    transition: 'all 500ms',
    '& h1': {
      paddingLeft: '60px'
    }
  },
  loaded: {
    opacity: '1'
  },
  animatingButton: {
    transitionTimingFunction: 'cubic-bezier(0, 0.25, 1)',
    position: 'relative',
    overflow: 'hidden',
    zIndex: '1',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: '0',
      left: '0',
      width: '100%',
      height: '100%',
      borderRadius: '10rem',
      zIndex: '-2'
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      bottom: '0',
      left: '0',
      width: '0%',
      height: '100%',
      backgroundColor: primary.darkBackground,
      transition: 'all 0s',
      transitionTimingFunction: 'cubic-bezier(0, 0.25, 1)',
      borderRadius: '10rem',
      zIndex: '-1'
    },
    '&.animating': {
      color: '#fff',
      '&:before': {
        transition: 'all 1s',
        width: '100%'
      }
    }
  },
  wrapperStyles: {
    width: '80%',
    maxWidth: 650,
    padding: [3.75 * unit, 0],
    margin: ({ page }) => (page ? `0 ${7.5 * unit}px` : '0 auto')
  },
  marginRight: {
    marginRight: 2.5 * unit
  }
});

export default createUseStyles(styles);
